import React, { useEffect } from "react";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useRootAppStore } from "@hooks";
import { ReactLazyImportWithGuard as lazy } from "@lib/lazy-import-with-guard";
import { useFixBody } from "@state/hooks/shared";
import { getCurrentCulture, isUserAuthenticated } from "@utils";
import { observer } from "mobx-react";

const loadFailPath = `/${getCurrentCulture()}/app-update`;

// prettier-ignore
const ReactMarkdown = lazy(loadFailPath, () => import("react-markdown"));

export default observer(function AccountVerificationPopup({
	isOpened,
}: {
	isOpened: boolean;
}) {
	const rootStore = useRootAppStore();

	useEffect(() => {
		return () => {
			rootStore.accountVerificationStore.onDispose();
		};
	}, []);

	const { t } = useTranslation("my-limits");

	useFixBody(true, isOpened);

	if (!isUserAuthenticated()) {
		return null;
	}

	return (
		<div className="at-accVerifPopup popup">
			<div className="popup__card popup__card--med">
				<div className="popup__header">
					<div className="popup__title">
						{t(`${rootStore.accountVerificationStore.buttonText}`)}
					</div>
				</div>
				<div className="popup__body">
					{rootStore.accountVerificationStore.partialDepositAmount !=
					null ? (
						<div className="message message--base message--note u-mar--bottom--sml">
							<i className="message__icon u-icon u-icon--lrg u-icon--info-circle u-color--sent--note" />
							<div className="message__content">
								{t("DEPOSIT_LIMIT_REACHED_PARTIAL_ONLY", {
									0: rootStore.accountVerificationStore
										.partialDepositAmount,
									1: rootStore.userAuthStore.currency,
								})}
							</div>
						</div>
					) : null}

					<div className="message message--base message--warning">
						<i className="message__icon u-icon u-icon--lrg u-icon--alert-circle u-color--sent--warning" />
						<ReactMarkdown className="message__content">
							{rootStore.accountVerificationStore.message || ""}
						</ReactMarkdown>
					</div>
				</div>
				<div className="popup__footer">
					{rootStore.accountVerificationStore
						.shouldShowCloseButton && (
						<button
							type="button"
							className="at-accVerifBtnSecondary popup__btn btn btn--med btn--primary--inverted"
							onClick={
								rootStore.accountVerificationStore.closePopup
							}
						>
							{t("COMMON.CLOSE")}
						</button>
					)}
					{rootStore.accountVerificationStore.partialDepositAmount !=
						null && (
						<button
							type="button"
							className="at-accVerifBtnSecondary popup__btn btn btn--med btn--primary--inverted"
							onClick={() => {
								rootStore.accountVerificationStore.closePopup();
								if (
									rootStore.accountVerificationStore
										.partialDepositFunction
								) {
									rootStore.accountVerificationStore.partialDepositFunction();
								}
							}}
						>
							{t("PARTIAL_DEPOSIT")}
						</button>
					)}
					<Link
						className="at-accVerifBtnSecondary popup__btn btn btn--med btn--primary--inverted"
						to={`/${getCurrentCulture()}/${
							rootStore.accountVerificationStore.url
						}`}
						onClick={rootStore.accountVerificationStore.closePopup}
					>
						{t(`${rootStore.accountVerificationStore.buttonText}`)}
					</Link>
				</div>
			</div>
		</div>
	);
});
